import { useTranslation } from 'next-i18next'
import { ComponentProps } from 'react'
import classNames from 'classnames/bind'

// Components
import { useLiveList } from '@/components/shared/LiveList/hooks/useLiveList'
import LiveSlide from '@/components/shared/LiveSlide'
import LiveSectionTitle from '../utils/LiveSectionTitle'
import Icon from '@/assets/icons'

// Constants
import { ROOM_LIVE_TYPE } from '@/constants/liveRoom'

// Styles
import styles from './style.module.scss'

const cx = classNames.bind(styles)

interface IActiveLivesProps {
  titleProps?: ComponentProps<typeof LiveSectionTitle>
  className?: string
}

const ActiveLives = ({ titleProps, className }: IActiveLivesProps) => {
  const { t } = useTranslation()
  const { data: liveRoomListRaw, fetchNextPage } = useLiveList({
    params: {
      pageSize: 10,
      liveTypes: [ROOM_LIVE_TYPE.CURRENT],
    },
  })
  const liveRooms = liveRoomListRaw?.pages.flatMap((page) => page?.roomList).filter((room) => !!room) ?? []

  if (!liveRooms.length) return null
  return (
    <div className={cx('active-lives', className)}>
      <LiveSectionTitle icon={<Icon.Streaming />} {...titleProps}>
        {t('Home_Active_Lives')}
      </LiveSectionTitle>
      <LiveSlide liveRooms={liveRooms} fetchNextPage={fetchNextPage} maxNumber={36} />
    </div>
  )
}

export default ActiveLives
